import award2018Logo from './assets/award2018.webp';
import award2019Logo from './assets/award2019.webp';
import award2022Logo from './assets/award2022.webp';
import award2023Logo from './assets/award2023.webp';
import award2024Logo from './assets/award2024.webp';

export const awardsTitle = 'An Award-Winning Platform for Capital Markets';

export const awardDescription = `
  FINSIGHT continues to receive recognition as a leading US Securitization data provider in an annual industry poll
hosted by GlobalCapital.
`;

export const awardsCollection = [
  {
    key: '2024',
    logo: award2024Logo.src,
    text: 'Securitization Tech\n Provider of the Year',
    alt: '2024',
  },
  {
    key: '2023',
    logo: award2023Logo.src,
    text: 'Securitization Trading Data\n Provider of the Year',
    alt: '2023',
  },
  {
    key: '2022',
    logo: award2022Logo.src,
    text: 'Securitization Trading Data\n Provider of the Year',
    alt: '2022',
  },
  {
    key: '2019',
    logo: award2019Logo.src,
    text: 'Securitization Tech\n Provider of the Year',
    alt: '2019',
  },
  {
    key: '2018',
    logo: award2018Logo.src,
    text: 'ABS Data\n Provider of the Year',
    alt: '2018',
  },
];
